export class ClaudeEnterpriseResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "parentOrganizationId",
            "baseName": "parentOrganizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "organizations",
            "baseName": "organizations",
            "type": "Array<ClaudeEnterpriseOrganization>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ClaudeEnterpriseResource.attributeTypeMap;
    }
    constructor() {
    }
}
